<template>
  <div class="container">
    <article class="message is-danger">
      <div class="message-body">
        <p>
          <strong>{{
            $texts(
              'notAvailableMessage',
              'The service is currently unavailable. Please try again later. We apologize for the inconvenience and thank you for your understanding.',
            )
          }}</strong>
        </p>
      </div>
    </article>
  </div>
</template>

<script lang="ts" setup>
const { $texts } = useEasyTexts()
</script>
